<template>
  <div class="container-fluid" ref="navRef">
    <div class="logopos">
      <img src="@/assets/logo.png" alt="货保保" title="货保保"/>货保保
    </div>
    <div class="row ctbox">
      <!-- 导航 -->

      <div
        class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
        style="padding-left: 0; padding-right: 0"
      >
        <div class="visible-lg-block">
          <!-- 固定的 -->
          <div :class="'navBox'">
            <div class="boxwidth">
              <div class="logo hidden-xs">
                <img
                  src="@/assets/logo.png"
                  alt="货保保"
                  title="货保保"
                  @click="routerPush('/home')"
                />
              </div>
              <!-- <div class="shade_title_logo visible-xs-inline-block">
                <img
                  src="@/assets/logo.png"
                  alt="货保保"
                  title="货保保"
                  @click="routerPush('/home')"
                />
              </div> -->

              <!-- 大屏幕导航 -->
              <div class="visible-lg-block">
                <ul class="navigation">
                  <li class="item">
                    <router-link
                      to="/home"
                      :class="
                        $route.fullPath === '/home' ? 'link active' : 'link'
                      "
                      >首页</router-link
                    >
                  </li>
                  <li class="item">
                    <router-link
                      to="/product"
                      :class="
                        $route.fullPath === '/product' ? 'link active' : 'link'
                      "
                      >产品服务</router-link
                    >
                  </li>
                  <li class="item">
                    <router-link
                      to="/aboutus"
                      :class="
                        $route.fullPath === '/aboutus' ? 'link active' : 'link'
                      "
                      >关于我们</router-link
                    >
                  </li>
                  <li class="item" @click="downFixedShow = true">App下载</li>
                </ul>
              </div>
              <!-- right_button 按钮 -->
              <div class="visible-lg-block">
                <button class="loginButton">
                  <a href="https://www.huobaobao.com/pc" target="_blank"
                    >电脑PC登录</a
                  >
                </button>
                <button class="registerButton">
                  <a href="http://erp.huobaobao.com/auth/login" target="_blank"
                    >ERP系统登录</a
                  >
                </button>
              </div>
            </div>
          </div>

          <!--  贴顶导航 navBox_f -->
          <div
            :class="fixedShow ? 'navBox_f' : 'navBox_f'"
            :style="
              fixedShow
                ? 'top:0;transition: all 0.5s'
                : 'top:-100px;transition: all 0.5s'
            "
          >
            <div class="boxwidth">
              <div class="logo hidden-xs">
                <img
                  src="@/assets/logo.png"
                  alt="货保保"
                  title="货保保"
                  @click="routerPush('/home')"
                />
              </div>
              <!-- 大屏幕导航 -->
              <div class="visible-lg-block">
                <ul class="navigation">
                  <li class="item">
                    <router-link
                      to="/home"
                      :class="
                        $route.fullPath === '/home' ? 'link active' : 'link'
                      "
                      >首页</router-link
                    >
                  </li>
                  <li class="item">
                    <router-link
                      to="/product"
                      :class="
                        $route.fullPath === '/product' ? 'link active' : 'link'
                      "
                      >产品服务</router-link
                    >
                  </li>
                  <li class="item">
                    <router-link
                      to="/aboutus"
                      :class="
                        $route.fullPath === '/aboutus' ? 'link active' : 'link'
                      "
                      >关于我们</router-link
                    >
                  </li>
                  <li class="item" @click="downFixedShow = true">App下载</li>
                </ul>
              </div>
              <!-- right_button 按钮 -->
              <div class="visible-lg-block">
                <button class="loginButton">
                  <a href="https://www.huobaobao.com/pc" target="_blank"
                    >电脑PC登录</a
                  >
                </button>
                <button class="registerButton">
                  <a href="http://erp.huobaobao.com/auth/login" target="_blank"
                    >ERP系统登录</a
                  >
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="hidden-lg">
          <div class="navBox1">
            <div class="logo hidden-xs">
              <img
                src="@/assets/logo.png"
                alt="货保保"
                title="货保保"
                @click="routerPush('/home')"
              />
            </div>
            <div class="shade_title_logo visible-xs-inline-block">
              <img
                src="@/assets/logo.png"
                alt="货保保"
                title="货保保"
                @click="routerPush('/home')"
              />
            </div>

            <!-- 中屏幕 导航 伸缩 -->
            <div class="visible-md-block visible-sm-block" @click="onshowShade">
              <svg class="icon iconBars" aria-hidden="true">
                <use href="#icon-icon-bars" />
              </svg>
            </div>

            <!-- 小屏幕 导航 伸缩 -->
            <div class="visible-xs-inline-block" @click="onshowShade">
              <svg class="icon iconBars2" aria-hidden="true">
                <use href="#icon-icon-bars" />
              </svg>
            </div>

            <!-- 导航 遮罩层 -->
            <div class="shade" v-if="shade">
              <!-- logo 图标 / button 按钮 -->
              <div class="shade_title">
                <div class="shade_title_logo">
                  <img src="@/assets/logo.png" alt="货保保" title="货保保" />
                </div>
                <div class="exit" @click="onshowShade">
                  <svg class="icon iconGuanbi" aria-hidden="true">
                    <use href="#icon-guanbi" />
                  </svg>
                </div>
              </div>

              <!-- navigation 导航 -->
              <div class="shade_nav">
                <div class="shade_nav_items" @click="routerPush('/home')">
                  <span>首页</span>
                </div>
                <div class="shade_nav_items" @click="routerPush('/product')">
                  产品服务
                </div>
                <div class="shade_nav_items" @click="routerPush('/aboutus')">
                  关于我们
                </div>
                <div class="shade_nav_items" @click="downFixedShow = true">
                  App下载
                </div>
              </div>
            </div>
          </div>

          <div
            class="navBox1_f"
            :style="
              fixedShow
                ? 'top:0;transition: all 0.5s;'
                : 'top:-100px;transition: all 0.5s;'
            "
          >
            <div class="logo hidden-xs">
              <img
                src="@/assets/logo.png"
                alt="货保保"
                title="货保保"
                @click="routerPush('/home')"
              />
            </div>
            <div class="shade_title_logo visible-xs-inline-block">
              <img
                src="@/assets/logo.png"
                alt="货保保"
                title="货保保"
                @click="routerPush('/home')"
              />
            </div>

            <!-- 中屏幕 导航 伸缩 -->
            <div class="visible-md-block visible-sm-block" @click="onshowShade">
              <svg class="icon iconBars" aria-hidden="true">
                <use href="#icon-icon-bars" />
              </svg>
            </div>

            <!-- 小屏幕 导航 伸缩 -->
            <div class="visible-xs-inline-block" @click="onshowShade">
              <svg class="icon iconBars2" aria-hidden="true">
                <use href="#icon-icon-bars" />
              </svg>
            </div>

            <!-- 导航 遮罩层 -->
            <div class="shade" v-if="shade">
              <!-- logo 图标 / button 按钮 -->
              <div class="shade_title">
                <div class="shade_title_logo">
                  <img src="@/assets/logo.png" alt="货保保" title="货保保" />
                </div>
                <div class="exit" @click="onshowShade">
                  <svg class="icon iconGuanbi" aria-hidden="true">
                    <use href="#icon-guanbi" />
                  </svg>
                </div>
              </div>

              <!-- navigation 导航 -->
              <div class="shade_nav">
                <div class="shade_nav_items" @click="routerPush('/home')">
                  <span>首页</span>
                </div>
                <div
                  class="shade_nav_items"
                  @click="$router.replace('/product')"
                >
                  产品服务
                </div>
                <div
                  class="shade_nav_items"
                  @click="$router.replace('/aboutus')"
                >
                  关于我们
                </div>
                <div class="shade_nav_items">App下载</div>
                <!-- <div class="shade_nav_items">电脑PC登录</div>
                <div class="shade_nav_items">ERP系统登录</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="downshade" v-if="downFixedShow">
        <div class="appdown">
          <div class="appdown_icon">
            <svg
              class="icon guanbi"
              aria-hidden="true"
              @click="downFixedShow = false"
            >
              <use href="#icon-guanbi" />
            </svg>
          </div>
          <div class="appdown_box">
            <h2 class="appdown_box_title">APP下载</h2>
            <div class="appdown_box_par">IOS和安卓均可扫码下载</div>
            <div class="appdown_box_qrcode">
              <div class="appdown_box_qrcode_img">
                <img
                  src="@/assets/appdown.png"
                  alt="APP扫码下载"
                  title="APP扫码下载"
                />
              </div>
              <div class="appdown_box_qrcode_text">扫码即刻下载</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 侧边 客服 / 返回顶部 按钮 -->
      <div
        class="fixedButton"
        :style="fixedRightShow ? 'right:10px;' : 'right:-99px;'"
      >
        <div class="fixedButton_items">
          <div class="fixedButton_items_icon">
            <svg class="icon iconKefu" aria-hidden="true">
              <use href="#icon-kefu" />
            </svg>
          </div>

          <div class="fixedButton_items_text">专属客服</div>

          <!-- 客服左侧悬浮框 -->
          <div class="fixedButton_items_left">
            <div class="fixedButton_items_left_top">
              <img
                src="@/assets/kefu_img.png"
                alt="货保保客服微信"
                title="货保保客服微信"
              />
              <p>客服微信号</p>
            </div>
            <div class="fixedButton_items_left_bottom">
              <div class="fixedButton_items_left_bottom_text">
                24小时咨询电话
              </div>
              <div class="fixedButton_items_left_bottom_phone">
                400-000-1395
              </div>
            </div>
          </div>
        </div>
        <div class="fixedButton_items" @click="onTop">
          <div class="fixedButton_items_icon">
            <svg class="icon iconShang" aria-hidden="true">
              <use href="#icon-shang" />
            </svg>
          </div>
          <div class="fixedButton_items_text">TOP</div>
        </div>
      </div>

      <!-- 主体 -->
      <div class="content" ref="ct">
        <slot name="content"></slot>
      </div>

      <!-- 尾部 -->
      <div class="footer visible-lg-block visible-md-block">
        <a href="https://www.huobaobao.com/pc/" target="_blank">
          <img src="@/assets/home/Bitmap.png" class="footer_img" />
        </a>
        <div class="footer_box">
          <div class="footer_box_top">
            <div class="footer_box_top_left">
              <div class="footer_box_top_left_items">
                <div class="footer_box_top_left_items_title">
                  <span>产品</span>矩阵
                </div>
                <p>APP：随时随地便捷采销</p>
                <p>PC：协同在线办公更高效</p>
                <p>ERP：进销存提供精准经营数据</p>
              </div>

              <div class="footer_box_top_left_items">
                <div class="footer_box_top_left_items_title">
                  <span>联系</span>我们
                </div>
                <p>咨询电话：400-000-1395</p>
                <p>联系邮箱：service@huobaobao.com</p>
                <p>联系地址：上海市宝山区沪太路5589号A座5F</p>
              </div>
            </div>
            <div class="footer_box_top_right">
              <div class="qrcode">
                <div class="qrcode_item">
                  <img
                    src="@/assets/wxCode.png"
                    alt="微信公众号"
                    title="微信公众号"
                  />
                  微信公众号
                </div>
                <div class="qrcode_item">
                  <img
                    src="@/assets/appCode.png"
                    alt="App下载"
                    title="App下载"
                  />
                  APP下载
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="copyright">
          Copyright © 2020 保盛科技
          <a href="javascript:;" style="color: #1a35fe">沪ICP备20002973号</a>
        </div>
      </div>

      <div class="footer1 visible-xs-block visible-sm-block">
        <div class="footer1_xs">
          <div class="footer1_xs_img" @click="downapp">
            <img src="@/assets/footer_img1.png" alt />
          </div>
          <div class="footer1_xs_box">
            <div class="footer1_xs_box_top">
              <div class="footer1_xs_box_top_left">
                <div class="footer1_xs_box_top_left_items">
                  <div class="footer1_xs_box_top_left_items_title">
                    <span>产品</span>矩阵
                  </div>
                  <p>APP：随时随地便捷采销</p>
                  <p>PC：协同在线办公更高效</p>
                  <p>ERP：进销存提供精准经营数据</p>
                </div>

                <div class="footer1_xs_box_top_left_items">
                  <div class="footer1_xs_box_top_left_items_title">
                    <span>联系</span>我们
                  </div>
                  <p>咨询电话：400-000-1395</p>
                  <p>联系邮箱：service@huobaobao.com</p>
                  <p>联系地址：上海市宝山区沪太路5589号A座5F</p>
                </div>
              </div>
              <div class="footer1_xs_box_top_right">
                <div class="qrcode1">
                  <div class="qrcode1_item1">
                    <img
                      src="@/assets/wxCode.png"
                      alt="微信公众号"
                      title="微信公众号"
                    />
                    微信公众号
                  </div>
                  <div class="qrcode1_item1">
                    <img
                      src="@/assets/appCode.png"
                      alt="App下载"
                      title="App下载"
                    />
                    APP下载
                  </div>
                </div>
              </div>
            </div>

            <div class="copyright">
              Copyright © 2020 保盛科技
              <a href="http://beian.miit.gov.cn/" target="_blank"
                >沪ICP备20002973号</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shade: false,
      fixedShow: false,
      downFixedShow: false,
      fixedRightShow: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      window.scrollY > 150 ? (this.fixedShow = true) : (this.fixedShow = false);
      window.scrollY > 350
        ? (this.fixedRightShow = true)
        : (this.fixedRightShow = false);
    });
  },
  methods: {
    onshowShade() {
      this.shade = !this.shade;
    },
    onTop() {
      window.document.documentElement.scrollTop = 0;
      window.document.body.scrollTop = 0;
    },
    downapp() {
      //用户设备信息
      const info = window.navigator.userAgent;
      //移动设备 / PC端
      const isUserAgent =
        info
          .toLowerCase()
          .match(
            /(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i
          ) != null;

      //移动设备
      if (isUserAgent) {
        if (
          info.toLowerCase().indexOf("android") > -1 ||
          info.toLowerCase().indexOf("lunix") > -1
        ) {
          //安卓
          window.location.href = "https://www.huobaobao.com/download/hbb.apk";
        }
        const isIOS = !!info.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isIOS) {
          //苹果
          window.location.href =
            "https://apps.apple.com/cn/app/%E8%B4%A7%E4%BF%9D%E4%BF%9D/id1458307068";
        }
      }
    },
    async routerPush(name) {
      if (this.$route.fullPath === name) {
        window.document.documentElement.scrollTop = 0;
        window.document.body.scrollTop = 0;
        return;
      }
      window.document.documentElement.scrollTop = this.$refs[
        "navRef"
      ].offsetTop;
      await this.onTop();

      await this.$router.replace(name);
    },
  },
};
</script>

<style lang="scss">
.visible {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 70px;
  height: viewSize(88);
  // transition: all 1s;
}

//右侧悬浮
.fixedButton {
  position: fixed;
  top: 50%;
  right: 10px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 80px;
  height: 130px;
  background-color: $primary_color;
  color: #fff;
  transition: all 1s;
  &_items {
    width: 100%;
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: 700;
    cursor: pointer;

    .iconKefu {
      font-size: 30px;
      font-weight: 700;
    }

    &:hover {
      background-color: #142bdb;
    }

    &:hover &_left {
      display: block;
      opacity: 1;
      transition: all 2s;
    }
    // 客服 左侧 悬浮框
    &_left {
      position: absolute;
      left: -156px;
      top: -170px;
      display: none;
      width: 150px;
      height: 230px;
      background-color: $primary_color;
      opacity: 0;
      &_top {
        padding: 10px;
        img {
          margin-bottom: 8px;
        }
        p {
          font-size: 14px;
          font-weight: 400;
        }
      }
      &_bottom {
        text-align: center;
        &_text {
          font-weight: 400;
          font-size: 14px;
          opacity: 0.6;
        }
        &_phone {
          font-weight: 400;
          font-size: 18px;
        }
      }
    }
  }

  &_items1 {
    width: 100%;
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: 700;
    cursor: pointer;

    .iconShang {
      font-size: 22px;
      font-weight: 700;
    }
    &:hover {
      background-color: #142bdb;
    }
  }
}

//APP下载悬浮
.downshade {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.6);
  z-index: 100;
  .appdown {
    width: 460px;
    height: 440px;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    &_icon {
      text-align: right;
      font-size: 22px;
      color: #bcbccc;
      cursor: pointer;
    }

    &_box {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      &_title {
        color: $primary_color;
        margin-top: 0;
        margin-bottom: 30px;
        font-weight: 700;
      }

      &_par {
        font-size: 18px;
        color: #2f2f33;
      }
      &_qrcode {
        &_img {
          width: 193px;
          height: 193px;
          margin: 24px;

          img {
            width: 100%;
          }
        }
        &_text {
          text-align: center;
          font-size: 18px;
          color: #000;
        }
      }
    }
  }
}

.navBox {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70px;
  height: viewSize(88);
  width: 100vw;
  background-color: rgba($color: #fff, $alpha: 1);
  padding: 0 viewSize(40);
  z-index: 99;
  // transition: all 10s;
  .boxwidth {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: viewSize(1300);
    // margin: auto;
  }

  .logo {
    text-align: left;
    img {
      min-height: 50px;
      vertical-align: top;
      height: 48px;
    }
  }

  .navigation {
    display: flex;
    justify-content: center;
    flex: 1;
    cursor: pointer;
    line-height: viewSize(48);
    max-height: 88px;
    li {
      margin: 20px;
      margin-right: viewSize(50);
      position: relative;
      border: 0;
      font-weight: 700;
      font-size: 16px;

      &:after {
        content: "";
        width: 0;
        height: 2px;
        background: $primary_color;
        position: absolute;
        top: 100%;
        left: 50%;
        transition: all 0.5s;
      }

      &:hover:after {
        left: 0%;
        width: 100%;
      }

      .link {
        display: inline-block;
        text-decoration: none;
        color: #000;
        width: 100%;
        height: 105%;
        &.active {
          // color: $primary_color !important;
          border-bottom: $primary_color solid 2px;
        }
      }
    }
  }

  //icon 图标
  .iconBars {
    color: $primary_color;
    font-size: 50px;
  }
  .iconBars2 {
    color: $primary_color;
    font-size: 30px;
  }
  //pc端 / erp系统 跳转按钮
  .loginButton,
  .registerButton {
    text-align: center;
    line-height: 38px;
    font-size: 14px;
    width: 102px;
    height: 38px;
    border-radius: 3px;
    outline: none;
    a {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
  .loginButton {
    border: 1px solid $primary_color;
    color: $primary_color;
    background-color: #fff;
    margin-right: 20px;
    a {
      color: $primary_color;
      text-decoration: none;
    }
  }
  .registerButton {
    background-color: $primary_color;
    color: #fff;
    border: 0;
    a {
      color: #fff;
      text-decoration: none;
    }
  }
}

.logopos {
  position: absolute;
  left: -200px;
  top: -200px;
}

.navBox_f {
  box-sizing: border-box;
  position: fixed;
  top: -100px;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70px;
  // height: viewSize(88);
  width: 100vw;
  background-color: rgba($color: #fff, $alpha: 0.95);
  padding: 0 viewSize(40);
  z-index: 99;
  // transition: all 10s;
  .boxwidth {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: viewSize(1300);
    // margin: auto;
  }

  .logo {
    text-align: left;
    img {
      min-height: 50px;
      vertical-align: top;
      height: 48px;
    }
  }

  .navigation {
    display: flex;
    justify-content: center;
    flex: 1;
    cursor: pointer;
    line-height: viewSize(48);
    max-height: 88px;
    li {
      margin: 20px;
      margin-right: viewSize(50);
      position: relative;
      border: 0;
      font-weight: 700;
      font-size: 16px;

      &:after {
        content: "";
        width: 0;
        height: 2px;
        background: $primary_color;
        position: absolute;
        top: 100%;
        left: 50%;
        transition: all 0.5s;
      }

      &:hover:after {
        left: 0%;
        width: 100%;
      }

      .link {
        display: inline-block;
        text-decoration: none;
        color: #000;
        width: 100%;
        height: 105%;
        &.active {
          // color: $primary_color !important;
          border-bottom: $primary_color solid 2px;
        }
      }
    }
  }

  //icon 图标
  .iconBars {
    color: $primary_color;
    font-size: 50px;
  }
  .iconBars2 {
    color: $primary_color;
    font-size: 30px;
  }
  //pc端 / erp系统 跳转按钮
  .loginButton,
  .registerButton {
    text-align: center;
    line-height: 38px;
    font-size: 14px;
    width: 102px;
    // height: 38px;
    border-radius: 3px;
    outline: none;
    a {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
  .loginButton {
    border: 1px solid $primary_color;
    color: $primary_color;
    background-color: #fff;
    margin-right: 20px;
    a {
      color: $primary_color;
      text-decoration: none;
    }
  }
  .registerButton {
    background-color: $primary_color;
    color: #fff;
    border: 0;
    a {
      color: #fff;
      text-decoration: none;
    }
  }
}

.navBox1 {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 70px;
  height: viewSize(88);
  width: 100%;
  background-color: rgba($color: #fff, $alpha: 0.95);
  padding: 0 viewSize(40);
  z-index: 99;
  transition: all 10s;
  .boxwidth {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: viewSize(1300);
    margin: auto;
  }

  .logo {
    text-align: left;
    img {
      min-height: 50px;
      vertical-align: top;
      height: 48px;
    }
  }

  .navigation {
    display: flex;
    justify-content: center;
    flex: 1;
    cursor: pointer;
    line-height: viewSize(48);
    max-height: 88px;
    li {
      margin: 20px;
      margin-right: viewSize(50);
      position: relative;
      border: 0;
      font-weight: 700;
      font-size: 16px;

      &:after {
        content: "";
        width: 0;
        height: 2px;
        background: $primary_color;
        position: absolute;
        top: 100%;
        left: 50%;
        transition: all 0.5s;
      }

      &:hover:after {
        left: 0%;
        width: 100%;
      }

      .link {
        display: inline-block;
        text-decoration: none;
        color: #000;
        width: 100%;
        height: 105%;
        &.active {
          // color: $primary_color !important;
          border-bottom: $primary_color solid 2px;
        }
      }
    }
  }

  //icon 图标
  .iconBars {
    color: $primary_color;
    font-size: 50px;
  }
  .iconBars2 {
    color: $primary_color;
    font-size: 30px;
  }
  //pc端 / erp系统 跳转按钮
  .loginButton,
  .registerButton {
    text-align: center;
    line-height: 38px;
    font-size: 14px;
    width: 102px;
    height: 38px;
    border-radius: 3px;
    outline: none;
  }
  .loginButton {
    border: 1px solid $primary_color;
    color: $primary_color;
    background-color: #fff;
    margin-right: 20px;
  }
  .registerButton {
    background-color: $primary_color;
    color: #fff;
    border: 0;
  }
}

.navBox1_f {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 70px;
  position: fixed;
  top: -100px;
  left: 0;
  height: viewSize(88);
  width: 100%;
  background-color: rgba($color: #fff, $alpha: 0.95);
  padding: 0 viewSize(40);
  z-index: 99;
  transition: all 10s;
  .boxwidth {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: viewSize(1300);
    margin: auto;
  }

  .logo {
    text-align: left;
    img {
      min-height: 50px;
      vertical-align: top;
      height: 48px;
    }
  }

  .navigation {
    display: flex;
    justify-content: center;
    flex: 1;
    cursor: pointer;
    line-height: viewSize(48);
    max-height: 88px;

    li {
      margin: 20px;
      margin-right: viewSize(50);
      position: relative;
      border: 0;
      font-weight: 700;
      font-size: 16px;

      &:after {
        content: "";
        width: 0;
        height: 2px;
        background: $primary_color;
        position: absolute;
        top: 100%;
        left: 50%;
        transition: all 0.5s;
      }

      &:hover:after {
        left: 0%;
        width: 100%;
      }

      .link {
        display: inline-block;
        text-decoration: none;
        color: #000;
        width: 100%;
        height: 105%;
        &.active {
          // color: $primary_color !important;
          border-bottom: $primary_color solid 2px;
        }
      }
    }
  }

  //icon 图标
  .iconBars {
    color: $primary_color;
    font-size: 50px;
  }
  .iconBars2 {
    color: $primary_color;
    font-size: 30px;
  }
  //pc端 / erp系统 跳转按钮
  .loginButton,
  .registerButton {
    text-align: center;
    line-height: 38px;
    font-size: 14px;
    width: 102px;
    height: 38px;
    border-radius: 3px;
    outline: none;
  }
  .loginButton {
    border: 1px solid $primary_color;
    color: $primary_color;
    background-color: #fff;
    margin-right: 20px;
  }
  .registerButton {
    background-color: $primary_color;
    color: #fff;
    border: 0;
  }
}

.content {
  // margin-top: viewSize(88);
  // width: viewSize(1300);
  z-index: 0;
}

.footer {
  z-index: 0;
  height: 360px;
  width: 100vw;
  text-align: center;
  // background-color: #abc;
  &_img {
    width: 100vw;
  }
  &_box {
    display: flex;
    width: viewSize(1300);
    margin: auto;
    border-bottom: 1px solid #ddd;
    &_top {
      height: 316px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      &_left {
        display: flex;
        text-align: left;
        &_items {
          // margin-right: 100px;
          width: 310px;
          color: #5e5e66;
          &_title {
            font-size: 20px;
            font-weight: 700;
            padding: 20px 0px 20px;
            color: #000;
            &::before {
              content: "";
            }
            span {
              display: inline-block;
              padding-bottom: 20px;
              border-bottom: 2px solid #2f2f33;
            }
          }
        }
      }
      &_right {
        flex: 1;
        .qrcode {
          // width: 50%;
          display: flex;
          justify-content: space-around;
          float: right;
          &_item {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            img {
              margin: 10px;
            }
          }
        }
      }
    }
  }
  .copyright {
    height: 74px;
    text-align: center;
    line-height: 74px;
  }
}

.footer1 {
  z-index: 0;
  width: 100vw;
  text-align: center;
  height: 586px;
  // background-color: #abc;
  &_xs {
    // height: 100%;
    display: flex;
    flex-direction: column;
    &_img {
      width: 100vw;
      // overflow: hidden;
      img {
        width: 100%;
      }
    }
    &_box {
      display: flex;
      // width: viewSize(1300);
      flex-direction: column;
      // margin: auto;
      // padding:0 16px;
      // border-bottom: 1px solid #ddd;
      &_top {
        width: 100%;
        display: flex;
        padding: 0 16px;
        flex-direction: column;
        justify-content: center;
        // align-items: center;
        &_left {
          // width: 100vw;
          display: flex;
          flex-direction: column;
          text-align: left;
          &_items {
            // margin-right: 100px;
            color: #5e5e66;
            &_title {
              font-size: 16px;
              font-weight: 700;
              margin-top: 39px;
              padding: 12px 0px 12px;
              color: #000;
              span {
                display: inline-block;
                padding-bottom: 12px;
                border-bottom: 2px solid #2f2f33;
              }
            }
          }
        }

        &_right {
          .qrcode1 {
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            &_item1 {
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
              margin: 10px;
              img {
                margin: 10px;
              }
            }
          }
        }
      }
      .copyright {
        width: 100vw;
        height: 55px;
        text-align: center;
        font-size: 12px;
        line-height: 55px;
        border-top: 1px solid #f6f6f6;
      }
    }
  }
}

// 遮罩层
.shade {
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 0;
  top: 0;
  z-index: 1000;
  height: 100vh;
  width: 100vw;
  padding: viewSize(50);
  background-color: rgba($color: #000000, $alpha: 0.9);
  z-index: 100;
  //title
  &_title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &_logo {
      text-align: center;
      height: 40px;
      img {
        height: 100%;
      }
    }
  }

  //navigation
  &_nav {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: viewSize(200);
    color: #fff;
    text-align: center;
    &_items {
      width: 50%;
      font-weight: 700;
      margin-top: 20px;
      padding-bottom: viewSize(200);
      font-size: 20px;
      cursor: pointer;
    }
  }

  // icon 图标
  .iconGuanbi {
    font-size: 30px;
    color: #fff;
  }
}
</style>